import React from 'react';
import { ArrowRight } from 'lucide-react';

interface CTAProps {
    onNavigate: (page: 'home' | 'blog' | 'contact' | 'resources' | 'products', sectionId?: string) => void;
}

const CTA: React.FC<CTAProps> = ({ onNavigate }) => {
  return (
    <section id="contact" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-black rounded-3xl relative overflow-hidden px-6 py-16 md:px-16 md:py-24 text-center shadow-2xl">
            {/* Abstract shapes */}
            <div className="absolute top-0 left-0 w-64 h-64 bg-orange-600/20 rounded-full blur-3xl -ml-20 -mt-20 pointer-events-none"></div>
            <div className="absolute bottom-0 right-0 w-80 h-80 bg-orange-600/10 rounded-full blur-3xl -mr-20 -mb-20 pointer-events-none"></div>

            <div className="relative z-10 max-w-5xl mx-auto">
                <h2 className="text-3xl md:text-5xl md:leading-tight font-extrabold text-white mb-6 tracking-tight">
                Ready to Build or Manufacture Your Supplement Brand?
                </h2>
                <p className="text-lg md:text-xl text-gray-400 mb-10 max-w-3xl mx-auto">
                The supplement industry doesn't need more chaos. It needs more founders who execute with integrity. Start with a free consultation.
                </p>
                
                <div className="flex justify-center">
                    <button 
                        onClick={() => onNavigate('contact')}
                        className="px-8 py-4 bg-orange-500 hover:bg-orange-600 text-black font-bold text-lg rounded-xl transition-all flex items-center justify-center whitespace-nowrap shadow-xl hover:shadow-orange-500/30 transform hover:-translate-y-1"
                    >
                        Book Consultation <ArrowRight className="ml-2 w-5 h-5" />
                    </button>
                </div>
                <p className="mt-6 text-sm text-gray-400 font-medium">No spam. No commitment. Just clarity.</p>
            </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;